import {SmartComponent} from "smart-component-js";

class SurveyComponent extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.link = this.element.querySelector('.survey-start-button a');
        this.infoWrapper = this.element.querySelector('.info-wrapper');
        this.formWrapper = this.element.querySelector('.form-wrapper');
        this.init();
    }


    addFormErrorListener() {
        document.addEventListener('yxp-form-config-error-require-logged-user', () => this.showFormWrapper());
        document.addEventListener('yxp-form-config-error-not-authorized', () => this.showFormWrapper());
        document.addEventListener('yxp-form-config-error-date-not-valid', () => this.showFormWrapper());
        document.addEventListener('yxp-form-config-error-already-answered', () => this.showFormWrapper());
        document.addEventListener('yxp-form-config-error', () => this.showFormWrapper());
        document.addEventListener('yxp-form-config-error-not-found', () => this.showFormWrapper());
    }

    showFormWrapper() {
        this.infoWrapper.classList.add('hidden');
        this.formWrapper.classList.remove('hidden');
    }

    init() {
        this.link?.addEventListener('click', () => this.showFormWrapper());
        this.addFormErrorListener();
        document.addEventListener('yxp-form-loaded', () => {
            const elementsAsImage = document.querySelectorAll("div.as-image input");

            elementsAsImage.forEach((element) => {
                const inputName = element.name;
                const inputValue = element.value;
                const path = `/upl/surveys/${inputName}_${inputValue}.jpg`;

                const image = document.createElement("img");
                image.src = path;
                image.alt = `${inputName} ${inputValue}`;

                element.insertAdjacentElement("afterend", image);
            });
        });

    }
}

export default SurveyComponent;
